import { useParams } from "react-router";
import { useHtzOrderShowQuery } from "@/services/backend/htz/orders/api/order-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  OrderCard,
  OrderCardSkeleton,
} from "@/routes/processes/[processId]/htz/orders/[orderId]/data/_components/order-card";

export function DataRoute() {
  const { orderId } = useParams();

  const {
    data: order,
    isLoading,
    error,
  } = useHtzOrderShowQuery({
    id: orderId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <OrderCardSkeleton />;
  }

  return <OrderCard order={order!} />;
}
